<template>
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M21 21H6C4.89543 21 4 20.1046 4 19V3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
        <path d="M9 13L9 18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
        <path d="M15 9L15 18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
        <path opacity="0.5" d="M20 6L20 18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
    </svg>
</template>

